import { render, staticRenderFns } from "./lezhi_project4.vue?vue&type=template&id=dd4d94ea&scoped=true&"
import script from "./lezhi_project4.vue?vue&type=script&lang=js&"
export * from "./lezhi_project4.vue?vue&type=script&lang=js&"
import style0 from "./lezhi_project4.vue?vue&type=style&index=0&id=dd4d94ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4d94ea",
  null
  
)

export default component.exports